import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Signup.css";
import { useSignup } from "../../hooks/useSignup";
import { Strings } from "../../Default/Strings";

const Signup: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const { signup, success, loading, error } = useSignup();
  const navigate = useNavigate();

  useEffect(() => {
    if (success) {
      navigate("/");
    }
  }, [success, navigate]);

  const validatePasswords = () => {
    if (password !== confirmPassword) {
      setPasswordError("As senhas não coincidem");
      return false;
    }
    if (password.length < 6) {
      setPasswordError("A senha deve ter pelo menos 6 caracteres");
      return false;
    }
    setPasswordError("");
    return true;
  };

  const handleSignup = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validatePasswords()) {
      return;
    }

    signup({ name, email, password });
  };

  return (
    <div className="signup-container">
      <img
        src="/turminha_logo.png"
        alt="Turminha Educa Logo"
        className="signup-logo"
      />
      <h1 className="signup-title">{Strings.SIGNUP.TITLE}</h1>
      <p className="signup-subtitle">{Strings.SIGNUP.SUBTITLE}</p>

      <form className="signup-form-vertical" onSubmit={handleSignup}>
        <input
          type="text"
          placeholder={Strings.SIGNUP.NAME_PLACEHOLDER}
          className="signup-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder={Strings.SIGNUP.EMAIL_PLACEHOLDER}
          className="signup-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder={Strings.SIGNUP.PASSWORD_PLACEHOLDER}
          className="signup-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder={Strings.SIGNUP.CONFIRM_PASSWORD_PLACEHOLDER}
          className="signup-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        {passwordError && (
          <p className="signup-error-message">{passwordError}</p>
        )}
        {error && <p className="signup-error-message">{error}</p>}

        <button className="signup-button" type="submit" disabled={loading}>
          {loading
            ? Strings.SIGNUP.CREATING_ACCOUNT
            : Strings.SIGNUP.CREATE_BUTTON}
        </button>

        <button
          className="signup-button-secondary"
          type="button"
          onClick={() => navigate("/login")}
        >
          {Strings.SIGNUP.LOGIN_BUTTON}
        </button>
      </form>
    </div>
  );
};

export default Signup;
